// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space-card[data-v-35b38e18]{margin:6px 0;padding:14px;border:1px solid var(--q4s-neutral-200);box-sizing:border-box;border-radius:4px;display:flex}.space-card img[data-v-35b38e18]{width:96px;height:52px}.space-card__name[data-v-35b38e18]{padding-left:15px;font-style:normal;font-weight:500;font-size:14px;line-height:20px;display:flex;flex-direction:column;justify-content:center;flex:1}", ""]);
// Exports
module.exports = exports;
